import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Header as Header$2, Title } from './style/header.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from '../Icon/Icon.js';
import { USER_INTERFACE_CROSS_CANCEL } from '../IconPath/USER_INTERFACE_CROSS_CANCEL.js';

var _excluded = ["close", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Header = function Header(_ref) {
  var close = _ref.close,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (close && typeof close !== 'function' || !close && !children) {
    return false;
  }
  var click = function click(e) {
    e.stopPropagation();
    close();
  };
  return /*#__PURE__*/jsxs(Header$2, _objectSpread(_objectSpread({}, rest), {}, {
    children: [/*#__PURE__*/jsx(Title, {
      children: children
    }), close && /*#__PURE__*/jsx(Icon, {
      className: "sg-popup-cancel-icon",
      path: USER_INTERFACE_CROSS_CANCEL,
      onClick: function onClick(e) {
        return click(e);
      },
      role: "button"
    })]
  }));
};
Header.defaultProps = {
  close: null,
  children: null
};
var Header$1 = Header;

export { Header$1 as default };
//# sourceMappingURL=_Header.js.map
